import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import CreaPropietario from "components/Ordenes/CreaPropietario";
import CreaVehiculo from "components/Ordenes/CreaVehiculo";
import CreaOrden from "views/Crea/CreaOrden";
import CreaTaller from "views/Crea/CreaTaller";
import InfoPreguntas from "views/examples/InfoPreguntas";
import PresentaLista from "views/examples/PresentaLista";
import AsignaEquipos from "components/Ordenes/AsignaEquipos";
import AdjuntosOrden from "components/Ordenes/AdjuntosOrden";
import Certificate from "views/examples/Certificado";
import CertificatePDF from "views/examples/CertificadoPdf";
import EditaOrden from "components/Ordenes/EditaOrden";
import InspectorTaller from "components/Ordenes/InspectorTaller";
import Perfil from "views/examples/Profile";
import Resultados from "views/examples/Resultados";
import ActualizaCambiosChip from "views/examples/ActualizaCambiosChip";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/admin/CreaPropitario" element={<CreaPropietario />} />
      <Route path="/admin/CreaVehiculo/:id" element={<CreaVehiculo />} />
      <Route path="/admin/CreaOrden/:id" element={<CreaOrden />} />
      <Route path="/admin/CreaTaller" element={<CreaTaller />} />
      <Route path="/admin/Cuestionario/:id" element={<InfoPreguntas />} />
      <Route
        path="/admin/PresentaLista/:id/:ordenId"
        element={<PresentaLista />}
      />
      <Route path="/admin/Perfil" element={<Perfil />} />
      <Route
        path="/admin/AsignaEquipo/:id/:tipoOrden"
        element={<AsignaEquipos />}
      />
      <Route
        path="/admin/AdjuntosOrden/:id/:ordenId"
        element={<AdjuntosOrden />}
      />
      <Route path="/certificado" element={<Certificate />} />
      <Route path="/InspectorTaller" element={<InspectorTaller />} />
      <Route path="/certificadoPDF" element={<CertificatePDF />} />
      <Route path="/admin/EditaOrden/:idOrden" element={<EditaOrden />} />
      <Route
        path="/admin/Resultados/:idOrden/:idVehiculo"
        element={<Resultados />}
      />
      <Route
        path="/admin/EdicionChip/:idOrden"
        element={<ActualizaCambiosChip />}
      />

      <Route path="*" element={<Navigate to="/auth/index" replace />} />
    </Routes>
  </BrowserRouter>,
);
